import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin: 25px auto 0 auto;
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }
`;
